<template>
  <div class="text-input-container">
    <div
      v-if="label"
      class="input-label-container"
    >
      <label
        v-if="label"
        class="input-label"
      > {{ label }} </label>
      <span
        v-if="showRequired"
        class="required-label"
      >(required)</span>
    </div>
    <input
      v-model="displayValue"
      v-bind="$attrs"
      class="input-field"
      :aria-label="label"
      :aria-required="showRequired"
      @blur="isActive = false"
      @focus="isActive = true"
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CurrencyInput',
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      default: undefined
    },
    showRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    displayValue: {
      get: function(): string {
        if (this.isActive)
          return this.modelValue.toString()

        return '$ ' + this.modelValue.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
      },
      set: function(modifiedValue: string): void {
        let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ''))
        if (isNaN(newValue))
          newValue = 0

        this.$emit('update:modelValue', newValue)
      }
    }
  }
})
</script>

<style scoped lang="scss">
.text-input-container {
  text-align: left;

  > .input-label-container {

    > .input-label {
      @include input-text-field-label;
    }

    > .required-label {
      @include input-text-field-label;
      margin-left: 5px;
      font-weight: 300;
    }
  }

  > .input-field {
    @include input-text-field;
  }
}
</style>
